<div class="loader-container" *ngIf="!view">
  <i  class="fas fa-spinner fa-spin"></i>
</div>
<div *ngIf="view">
  <app-view [items]="view.data?.content" [info]="view?.data"></app-view>
  <!-- <div class="course-select-card" *ngFor="let co of view">
      <app-course-card [course]="co"></app-course-card>
  </div> -->
</div>
